/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ApiResponseGetDailyUbiResponse } from '../models/ApiResponseGetDailyUbiResponse';
import type { ApiResponseGetHourlyUbiResponse } from '../models/ApiResponseGetHourlyUbiResponse';
import type { ApiResponseGetMonthlyUbiResponse } from '../models/ApiResponseGetMonthlyUbiResponse';
import type { ApiResponseGetUbiPredctionResponse } from '../models/ApiResponseGetUbiPredctionResponse';
import type { ApiResponseGetUbiResponse } from '../models/ApiResponseGetUbiResponse';
import type { ApiResponseGetUbiSummaryResponse } from '../models/ApiResponseGetUbiSummaryResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class UbiForMyAppControllerService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * 안전운전점수 summary
   * @returns ApiResponseGetUbiSummaryResponse OK
   * @throws ApiError
   */
  public getUbiSummary({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetUbiSummaryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/myapp/ubi/summary/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 안전운전점수 summary
   * @returns ApiResponseGetUbiSummaryResponse OK
   * @throws ApiError
   */
  public getUbiSummary1({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetUbiSummaryResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/myapp/ubi/summary',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 안전운전점수 예측결과
   * @returns ApiResponseGetUbiPredctionResponse OK
   * @throws ApiError
   */
  public getUbiPrediction({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetUbiPredctionResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/myapp/ubi/prediction',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 안전운전점수 월별리포트
   * @returns ApiResponseGetMonthlyUbiResponse OK
   * @throws ApiError
   */
  public getMonthlyUbi({
    vin,
    startDate,
    endDate,
    authorization,
  }: {
    vin: string,
    startDate: string,
    endDate: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetMonthlyUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/myapp/ubi/monthly',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 안전운전점수 월별리포트
   * @returns ApiResponseGetMonthlyUbiResponse OK
   * @throws ApiError
   */
  public getMonthlyUbi1({
    vin,
    startDate,
    endDate,
    authorization,
  }: {
    vin: string,
    startDate: string,
    endDate: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetMonthlyUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/myapp/ubi/monthly/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 안전운전점수 시간대별 리포트
   * @returns ApiResponseGetHourlyUbiResponse OK
   * @throws ApiError
   */
  public getHourlyUbi({
    vin,
    startDate,
    endDate,
    authorization,
  }: {
    vin: string,
    startDate: string,
    endDate: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetHourlyUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/myapp/ubi/hourly',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 안전운전점수 시간대별 리포트
   * @returns ApiResponseGetHourlyUbiResponse OK
   * @throws ApiError
   */
  public getHourlyUbi1({
    vin,
    startDate,
    endDate,
    authorization,
  }: {
    vin: string,
    startDate: string,
    endDate: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetHourlyUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/myapp/ubi/{vin}/hourly/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 안전운전점수 일별리포트
   * @returns ApiResponseGetDailyUbiResponse OK
   * @throws ApiError
   */
  public getDailyUbi({
    vin,
    startDate,
    endDate,
    authorization,
  }: {
    vin: string,
    startDate: string,
    endDate: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetDailyUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/myapp/ubi/daily/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 안전운전점수 일별리포트
   * @returns ApiResponseGetDailyUbiResponse OK
   * @throws ApiError
   */
  public getDailyUbi1({
    vin,
    startDate,
    endDate,
    authorization,
  }: {
    vin: string,
    startDate: string,
    endDate: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetDailyUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/myapp/ubi/daily',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
        'startDate': startDate,
        'endDate': endDate,
      },
    });
  }
  /**
   * 안전운전점수 상세
   * @returns ApiResponseGetUbiResponse OK
   * @throws ApiError
   */
  public getUbi2({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/myapp/ubi',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
  /**
   * 안전운전점수 상세
   * @returns ApiResponseGetUbiResponse OK
   * @throws ApiError
   */
  public getUbi3({
    vin,
    authorization,
  }: {
    vin: string,
    authorization?: string,
  }): CancelablePromise<ApiResponseGetUbiResponse> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/myapp/ubi/',
      headers: {
        'Authorization': authorization,
      },
      query: {
        'vin': vin,
      },
    });
  }
}
